import { useMemo, useState } from 'react'
import { HostServicesListCard } from '../../presentationals/HostServicesListCard'
import type { MapBounds } from 'shared/types/MapBounds'


interface HostServicesListCardContainerProps {
    hostServices?: any[]
    hostServicesReduced? : any[]
    hostServicesFilteredByMapBounds?: any[]
    count?: number
    spyId?: number
    mapBounds?: MapBounds
    loading?: boolean,
    onStartPropertySpy: (event: any) => void
    onStopPropertySpy: (event: any) => void
}

export const HostServicesListCardContainer = (props: HostServicesListCardContainerProps): JSX.Element => {
    const {
        hostServices,
        hostServicesReduced,
        hostServicesFilteredByMapBounds,
        mapBounds,
        spyId,
        loading,
        onStartPropertySpy,
        onStopPropertySpy
    } = props

    return (
        <HostServicesListCard
            loading={loading}
            hostServices={hostServices}
            hostServicesReduced={hostServicesReduced}
            hostServicesFilteredByMapBounds={hostServicesFilteredByMapBounds}
            spyId={spyId}
            onStartPropertySpy={onStartPropertySpy}
            onStopPropertySpy={onStopPropertySpy}
        />
    )
}